module.exports = __webpack_public_path__ + "img/transition-4.b0230f3a.png";